import { render } from "./RestrictionMeasureTableComponent.vue?vue&type=template&id=fd6267de&scoped=true"
import script from "./RestrictionMeasureTableComponent.vue?vue&type=script&lang=js"
export * from "./RestrictionMeasureTableComponent.vue?vue&type=script&lang=js"

import "./RestrictionMeasureTableComponent.vue?vue&type=style&index=0&id=fd6267de&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd6267de"]])

export default __exports__